import { lazy, useEffect } from "react";
import { useUIStore } from "../../../../stores/UIStore";
import lazyRetry from "../../../../functions/lazyRetry";
const Grape = lazyRetry(() => import("../../../../components/Grape/Grape"));

const FormCreate = () => {
  useEffect(() => {
    useUIStore.getState().setHeaderClosed(true);

    return () => {
      useUIStore.getState().setHeaderClosed(false);
    };
  }, []);

  return (
    <>
      <Grape />
    </>
  );
};

export default FormCreate;
